import axios from 'axios';
import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit';
import { authTypes } from '@store/slices/auth';
import { API_BASE_NO_API, tabActions } from '@store/index';
import { deleteCookie } from '.';

export const logout = createAsyncThunk('auth/logout', async (_, store: any) => {
  localStorage.removeItem('internalUserId');
  localStorage.removeItem('internalOrgId');

  store.dispatch(tabActions.clear());

  // remove the flow cookie
  deleteCookie('flow_auth', '/', '.telnyx.com');

  const response = await axios({
    method: 'delete',
    url: `${API_BASE_NO_API}/${LOCAL || INTERNAL_CLIENT ? 'auth/logout' : 'logout'}`,
    // withCredentials: true,
  });

  return response?.data;
});

export const logoutThunk = (builder: ActionReducerMapBuilder<authTypes>) => {
  return [
    builder.addCase(logout.pending, (state: authTypes) => {
      state.logoutLoading = true;
      state.isLoggedIn = false;
      state.username = null;
    }),
    builder.addCase(logout.fulfilled, (state: authTypes) => {
      state.logoutLoading = false;
      state.isLoggedIn = false;
      state.username = null;
    }),
    builder.addCase(logout.rejected, (state: authTypes) => {
      state.logoutLoading = false;
      state.isLoggedIn = false;
      state.username = null;
    }),
  ];
};
